import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiUrl } from './apiUrl';

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  constructor(private api: ApiService) {}

  getTickets(params?: any): Observable<any> {
    let url = ApiUrl.supportTickets;
    if (params) {
      const queryParts: string[] = [];
      Object.keys(params).forEach(key => {
        const val = params[key];
        if (val !== null && val !== undefined && val !== '') {
          queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
        }
      });
      if (queryParts.length > 0) {
        url += '?' + queryParts.join('&');
      }
    }
    return this.api.getRequest(url);
  }

  getTicketStats(): Observable<any> {
    return this.api.getRequest(ApiUrl.supportTicketStats);
  }

  getTicket(id: string): Observable<any> {
    return this.api.getRequest(ApiUrl.supportTicket(id));
  }

  createTicket(formData: FormData): Observable<any> {
    return this.api.postRequest(ApiUrl.supportTickets, formData);
  }

  updateTicketStatus(id: string, status: string): Observable<any> {
    return this.api.putRequest(ApiUrl.supportTicketStatus(id), { status });
  }

  assignTicket(id: string, assignedTo: string): Observable<any> {
    return this.api.putRequest(ApiUrl.supportTicketAssign(id), { assignedTo });
  }

  getMessages(ticketId: string): Observable<any> {
    return this.api.getRequest(ApiUrl.supportTicketMessages(ticketId));
  }

  addMessage(ticketId: string, formData: FormData): Observable<any> {
    return this.api.postRequest(ApiUrl.supportTicketMessages(ticketId), formData);
  }

  getArticles(params?: any): Observable<any> {
    let url = ApiUrl.supportArticles;
    if (params) {
      const queryParts: string[] = [];
      Object.keys(params).forEach(key => {
        const val = params[key];
        if (val !== null && val !== undefined && val !== '') {
          queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
        }
      });
      if (queryParts.length > 0) {
        url += '?' + queryParts.join('&');
      }
    }
    return this.api.getRequest(url);
  }

  getArticle(id: string): Observable<any> {
    return this.api.getRequest(ApiUrl.supportArticle(id));
  }

  createArticle(data: any): Observable<any> {
    return this.api.postRequest(ApiUrl.supportArticles, data);
  }

  updateArticle(id: string, data: any): Observable<any> {
    return this.api.putRequest(ApiUrl.supportArticle(id), data);
  }

  deleteArticle(id: string): Observable<any> {
    return this.api.deletRequest(ApiUrl.supportArticle(id));
  }

  getSystemUpdates(): Observable<any> {
    return this.api.getRequest(ApiUrl.systemUpdateList);
  }

  createSystemUpdate(data: any): Observable<any> {
    return this.api.postRequest(ApiUrl.systemUpdateList, data);
  }

  updateSystemUpdate(id: string, data: any): Observable<any> {
    return this.api.putRequest(ApiUrl.systemUpdateById + id, data);
  }

  deleteSystemUpdate(id: string): Observable<any> {
    return this.api.deletRequest(ApiUrl.systemUpdateById + id);
  }

  getKbCategories(): Observable<any> {
    return this.api.getRequest(ApiUrl.kbCategoryList);
  }

  createKbCategory(data: any): Observable<any> {
    return this.api.postRequest(ApiUrl.kbCategoryList, data);
  }

  updateKbCategory(id: string, data: any): Observable<any> {
    return this.api.putRequest(ApiUrl.kbCategoryById + id, data);
  }

  deleteKbCategory(id: string): Observable<any> {
    return this.api.deletRequest(ApiUrl.kbCategoryById + id);
  }
}
